import { resolveEvaluationMetricLabel } from "helpers/customLabels";
import { CustomLabel, CustomLabelType } from "types/CustomLabel";

const TARGET_ACHIEVEMENT_TIME_EPA: { [key: number]: string } = {
  1: "End of First year",
  2: "End of Second year",
  3: "End of Third year",
  4: "End of Fourth year",
  5: "End of Fifth year",
  6: "Post-Graduation",
};

// Temporary until the custom label is finalized
const TEMP_ACHIEVEMENT_TIME: { [key: number]: string } = {
  1: "First 3 months",
  2: "First 6 months",
  3: "First 9 months",
  4: "End of Internship",
  5: "Post-Internship",
  6: "Post-Internship",
};

export const getTargetAchievementTime = (
  type: string,
  key: number,
  customLabels: CustomLabel[] = [],
) => {
  let orgLabel: string | undefined;
  if (customLabels.length > 0) {
    const typeKey =
      type === "EPA"
        ? CustomLabelType.TARGET_ACHIEVEMENT_TIME_EPA
        : CustomLabelType.TARGET_ACHIEVEMENT_TIME_COMPETENCY;
    const scoped = customLabels.filter((c) => c.type === typeKey);
    orgLabel = scoped.find((c) => c.index === key)?.label;
  }

  const defaultLabel =
    type === "EPA"
      ? TEMP_ACHIEVEMENT_TIME[key]
      : TARGET_ACHIEVEMENT_TIME_EPA[key];

  // Target Achievement Time: org custom labels beat hardcoded defaults.
  // Metric-level labels are intentionally ignored.
  return resolveEvaluationMetricLabel(null, orgLabel, defaultLabel);
};
